// extracted by mini-css-extract-plugin
module.exports = {"details":"product-card-skeleton_details__6qlkU","tags":"product-card-skeleton_tags__4Flo9"};